export const FACILITY_TYPE_2_FACILITY_DATA_KEY = {
  wind: 'windFacilityData',
  wasser: 'waterFacilityData',
  photovoltaik: 'solarFacilityData',
  biomasse: 'bioMasseFacilityData',
} as const;

export type FacilityType = keyof typeof FACILITY_TYPE_2_FACILITY_DATA_KEY;
export type FacilityDataKey =
  (typeof FACILITY_TYPE_2_FACILITY_DATA_KEY)[FacilityType];

export const FACILITY_TYPE_2_NUMBER_FIELDS: Record<FacilityType, string[]> = {
  wind: [
    'hubHeight',
    'diameter',
    'output',
    'powerDensity',
    'latitude',
    'longitude',
  ],
  wasser: ['output', 'generated', 'latitude', 'longitude'],
  photovoltaik: ['output', 'generated', 'latitude', 'longitude'],
  biomasse: ['generated', 'latitude', 'longitude'],
};
